import React from "react";
import { makeStyles } from "@mui/styles";
import Header from "./Header";
import About from "./About";
import Product from "./Product";
import red from "../../../assets/Images/red.mp4";
import Work from "./Work";

const customStyles = makeStyles({
  root: {
    position: "relative",
    minHeight: "100vh",
    padding: "190px 0px 150px 0px",
    backgroundColor: "white",
    zIndex: 1,
    transition: "background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s",
  },

  videoWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    zIndex: 0,
    direction: "ltr",
  },

  videoBG: {
    objectFit: "cover",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    zIndex: -1,
    pointerEvents: "none",
  },

  redBg: {
    backgroundColor: "#d6263b",
    opacity: 1,
    transition: "background 0.3s, border-radius 0.3s, opacity 0.3s",
    height: "100%",
    width: "100%",
    top: 0,
    left: 0,
    position: "absolute",
  },

  // Media Query for Extra Small Screens (<320px)
  '@media (max-width: 319px)': {
    root: {
      padding: "50px 0px 60px 0px",
    },
  },

  // Media Query for Small Screens (320px - 480px)
  '@media (min-width: 320px) and (max-width: 480px)': {
    root: {
      padding: "70px 0px 80px 0px",
    },
  },

  // Media Query for Medium Screens (481px - 768px)
  '@media (min-width: 481px) and (max-width: 768px)': {
    root: {
      padding: "100px 0px 110px 0px",
    },
  },

  // Media Query for Large Screens (769px - 1024px)
  '@media (min-width: 769px) and (max-width: 1024px)': {
    root: {
      padding: "120px 0px 130px 0px",
    },
  },
});



const Layout = () => {
  const classes = customStyles();

  return (
    <div className={classes.root}>
      <div className={classes.videoWrapper}>
        <video
          autoPlay
          loop
          playsInline
          className={classes.videoBG}
        >
          <source src={red} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* <div className={classes.redBg} /> */}
        <div>
          
        </div>
      </div>
      <Header />
      <About />
      <Product />
       <Work/>
    </div>
    
  );
};


export default Layout;
